// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eEVl","right":"styles_right__3j2xI"};